import PropTypes from 'prop-types';

const TABLE_PROP_TYPES = PropTypes.shape({
  columns: PropTypes.arrayOf(PropTypes.shape()),
  rows: PropTypes.arrayOf(PropTypes.shape()),
});

export default TABLE_PROP_TYPES;
